export default __webpack_public_path__ + "static/media/Wood.6252b0f6.png";